import { MessageCircle } from 'lucide-react'
import { useEffect } from 'react'
import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar'
import { useAuthStore } from '@/stores/auth-store'

const BOTPRESS_WEBCHAT_URL = import.meta.env.VITE_BOTPRESS_WEBCHAT_URL
const BOTPRESS_CONFIG_URL = import.meta.env.VITE_BOTPRESS_CONFIG_URL

export const BOTPRESS_ENABLED =
  BOTPRESS_WEBCHAT_URL !== undefined &&
  BOTPRESS_WEBCHAT_URL !== '' &&
  BOTPRESS_CONFIG_URL !== undefined &&
  BOTPRESS_CONFIG_URL !== ''

let botpressLoaded = false

declare global {
  interface Window {
    botpress?: {
      initialized: boolean
      updateUser: (data: Record<string, string>) => void
      getUser: () => Record<string, string>
      open: () => void
      close: () => void
      toggle: () => void
      on: (event: string, callback: () => void) => void
    }
  }
}

export function BotpressChat(): React.ReactNode {
  const user = useAuthStore((state) => state.user)

  useEffect(() => {
    if (!BOTPRESS_ENABLED || botpressLoaded) return

    botpressLoaded = true

    const webchat = document.createElement('script')
    webchat.async = false
    webchat.src = BOTPRESS_WEBCHAT_URL as string

    const config = document.createElement('script')
    config.async = false
    config.src = BOTPRESS_CONFIG_URL as string

    document.head.appendChild(webchat)
    document.head.appendChild(config)
  }, [])

  useEffect(() => {
    if (!BOTPRESS_ENABLED || !user) return

    const currentUser = user

    function sendUserData(): void {
      window.botpress?.updateUser({
        id: String(currentUser.id),
        name: `${currentUser.first_name} ${currentUser.last_name}`,
        email: currentUser.email,
      })
    }

    if (window.botpress?.initialized) {
      sendUserData()
    } else if (window.botpress) {
      window.botpress.on('webchat:initialized', sendUserData)
    }
  }, [user])

  if (!BOTPRESS_ENABLED) return null

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        id="botpress-chat-trigger"
        tooltip="Chat"
        className="text-sidebar-foreground/50 hover:text-sidebar-foreground/80 h-8 gap-4 rounded-sm px-2.5 text-xs"
      >
        <MessageCircle className="size-5" />
        <span>Chat</span>
      </SidebarMenuButton>
    </SidebarMenuItem>
  )
}
